import { render, staticRenderFns } from "./AltUsers.vue?vue&type=template&id=c673ffd8&scoped=true"
import script from "./AltUsers.vue?vue&type=script&lang=js"
export * from "./AltUsers.vue?vue&type=script&lang=js"
import style0 from "./AltUsers.vue?vue&type=style&index=0&id=c673ffd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c673ffd8",
  null
  
)

export default component.exports